import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core'

class LetContext<T> {
	constructor(private readonly dir: LetDirective<T>) {}

	get ngLet(): T {
		return this.dir.ngLet
	}
}

// tslint:disable-next-line:directive-selector
@Directive({ selector: '[ngLet]' })
export class LetDirective<T> {
	@Input() ngLet!: T

	constructor() {
		const viewContainer = inject<ViewContainerRef>(ViewContainerRef)
		const templateRef = inject<TemplateRef<LetContext<T>>>(TemplateRef)

		viewContainer.createEmbeddedView(templateRef, new LetContext<T>(this))
	}
}
